import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import useService from "../../../../../../../hooks/useService";

import AvailabilityTableRow from "./AvailabilityTableRow";

export default function AvailabilityTable({ caseObj }) {
  const enumRepository = useService("repositories/enum-repository");
  const { availabilityData } = useLoaderData();
  const [operationHours, setOperationHours] = useState([]);
  const [defaultWeek, setDefaultWeek] = useState([]);

  async function getDefaultWeek() {
    try {
      const response = await enumRepository.query({
        urlPath: "field_options/?content_type=usercontacthours&field=day&ordering=order",
      });
      setDefaultWeek(response);
    } catch (error) {
      console.error("Error fetching default week:", error);
    }
  }

  const createHoursArr = (data, valKey) => {
    const arr = [];
    if (data.length === 0) {
      return arr;
    } else {
      for (const item in data) {
        if (valKey === data[item].day) {
          arr.push(data[item]);
        }
      }
    }
    return arr;
  };

  useEffect(() => {
    getDefaultWeek();
  }, []);

  useEffect(() => {
    setOperationHours(availabilityData || []);
  }, [availabilityData]);

  if (!defaultWeek) {
    return null;
  }

  return (
    <>
      {defaultWeek.map((day) => {
        return (
          <AvailabilityTableRow
            key={day.key}
            day={day.label}
            dayKey={day.key}
            defaultValues={createHoursArr(operationHours, day.key)}
            client={caseObj.client.pk}
          />
        );
      })}
    </>
  );
}
